import { useEffect, useState } from 'react';

/** Keeps a keystroke from becoming a request, which matters on venue wifi (Q-02). */
export function useDebounced(value: string, delayMs: number): string {
  const [debounced, setDebounced] = useState(value.trim());

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value.trim()), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
